import React, { forwardRef } from 'react';
import cn from 'clsx';
import { getSizingProp } from '../CrescentCss/CrescentCss';

import { StyledInput } from './Input.styles';
import { InputProps } from './Input.types';

namespace Input {
    export type Props = InputProps & React.RefAttributes<HTMLInputElement>;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, compact, validation, ...rest }, ref) => (
    <StyledInput
        data-cds-state={validation}
        className={cn('bbui-input', className)}
        ref={ref}
        {...getSizingProp(compact)}
        {...rest}
    />
));

Input.displayName = 'Input';

export default Input;
